var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningExclamation = function SvgWarningExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD7F38",
    fillOpacity: 0.2,
    d: "M10.05 3.378c.867-1.5 3.033-1.5 3.899 0l7.354 12.748c.865 1.5-.217 3.374-1.949 3.374H4.645c-1.731 0-2.814-1.874-1.948-3.374z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD7F38",
    fillOpacity: 0.2,
    d: "M12 15.75h.007v.008H12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD7F38",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0zM12 15.75h.007v.008H12z"
  })));
};
export { SvgWarningExclamation as ReactComponent };
export default __webpack_public_path__ + "3b873a721355f44bcae7d94d62fc52e2.svg";